import ActionTypes from "../../../../constants/ActionTypes";
import { AnyAction } from "redux";
import { IManhattanBundleSubmit } from "../../../../entities/manhattan/submit/types";
import Consumers from "../../../../constants/Consumers";
import Languages from "../../../../constants/Languages";

const initialState: IManhattanBundleSubmit = {
  segment: Consumers.PRIVATE_CONSUMER,
  selectedProducts: [
    {
      id: 0,
      productLine: "",
    },
  ],
  lang: Languages.SR
};

const bundleDataReducer = (
  state = initialState,
  action: AnyAction
): any => {
  switch (action.type) {
  case ActionTypes.MANHATTAN.BUNDLE_DATA.SET_DATA:
    return {
      ...state,
      segment: action.payload.segment,
      selectedProducts: action.payload.selectedProducts,
      lang: action.payload.lang,
    };
  case ActionTypes.MANHATTAN.BUNDLE_DATA.SET_SELECTED_PRODUCTS:
    return {
      ...state,
      selectedProducts: action.payload,
    };
  }
  return state;
};

export default bundleDataReducer;
